import { render } from "./HomeEducation.vue?vue&type=template&id=2036b58a&scoped=true"
import script from "./HomeEducation.vue?vue&type=script&lang=js"
export * from "./HomeEducation.vue?vue&type=script&lang=js"

import "./HomeEducation.vue?vue&type=style&index=0&id=2036b58a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2036b58a"]])

export default __exports__